import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/404',
    name: '404',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/user_center',
    name: 'UserCenter',
    component: () => import('../views/UserCenter.vue')
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/Recharge.vue')
  },
  {
    path: '/recharge_bank/:rule_id/:pay_id',
    name: 'RechargeBank',
    component: () => import('../views/RechargeBank.vue'),
    props: true
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('../views/Withdraw.vue')
  },
  {
    path: '/withdraw_apply',
    name: 'WithdrawApply',
    component: () => import('../views/WithdrawApply.vue')
  },
  {
    path: '/exchange',
    name: 'Exchange',
    component: () => import('../views/Exchange.vue')
  },
  {
    path: '/bank_edit',
    name: 'BankEdit',
    component: () => import('../views/BankEdit.vue')
  },
  {
    path: '/twitter_callback',
    name: 'TwitterCallback',
    component: () => import('../views/TwitterCallback.vue')
  },
  {
    path: '/line_callback',
    name: 'LineCallback',
    component: () => import('../views/LineCallback.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function isLogin() {
  var is_login = (localStorage.token != null && localStorage.token.length > 0)

  return is_login
}

const publicPages = [
  /^\/$/, /^\/login/, /^\/404/, /_callback$/
]

router.beforeEach((to, from, next) => {
  // 定義されていないパスを処理します
  if(routes.find((o) => { return to.path.startsWith(o.path) }) == null) {
    next({
      path: '/404'
    })
    return
  }

  //if (to.matched.some((record) => record.meta.requireAuth)) {
  if(publicPages.find((o) => { return o.test(to.path); }) == null) {
    if(isLogin()) {
      next()
    } else {
      console.log('[D]Not login, Redirect to /login ...')
      next({
        path: '/login',
        //query: { redirect: to.fullPath }
      })
    }
  } else {
    next() // next()を常に呼び出すようにしてください!
  }
})

export default router
